// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__oAFuk","requiredAsterisk":"Info_requiredAsterisk__1yhlz"};